import { ft } from '../../../lib/utils';

export const KEY_COMPONENT_NAME = 'fast2-';
export const KEY_ECHART_NAME = 'echart-';
export const DIC_PROPS = {
  nodeKey: 'id',
  label: 'label',
  value: 'value',
  groups: 'groups',
  leaf: 'leaf',
  children: 'children',
  labelText: ft('i18n_common_name', '名称'),
  disabled: 'disabled'
};
export const DIC_HTTP_PROPS = {
  name: 'name',
  url: 'url',
  fileName: 'file',
  res: ''
};
export const DIC_SPLIT = ' | ';
